<template lang="pug">
  #MsgManagerIndex.container-width
    h5.text-center.py-3.letter-spacing-6 訊息管理
    .tabDiv.d-flex.mb-3
      div(@click="getMessage(1)" :class="{'active': selectedTab === 1}") 所有訊息
      div(@click="getMessage(2)" :class="{'active': selectedTab === 2}") 未讀訊息
      div(@click="getMessage(3)" :class="{'active': selectedTab === 3}") 我的最愛

    div
      b-card.border-0.mb-5.customerCard.word-break-all(
        bg-variant="light",
        v-for="(user,index) in msgList",
        :key="user.id",
        @click="openMsgHandler(user)",
        body-class="p-0"
      )
        .px-3.pt-3
          .row.no-gutters
            .col-4.pr-1.d-flex.align-items-center.no-gutters
              ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                :profileUrl="user.picture_url",
                :style="{ 'width': '70px', 'height': '70px' }"
              )
            .col-8
              .row.no-gutters
                .col-9.px-1
                  .d-flex
                    p.mb-0.font-weight-bold.text-17 {{ user.member_last_name }}{{ user.member_first_name }}
                    b-badge.ml-3.px-2.text-center(
                      variant="black",
                      v-if="user.blacklist_tag"
                      style="padding-top: 6px;"
                    ) 黑名單
                  .row.no-gutters
                    .col-5
                      small.mb-0.text-justify 暱稱名：
                    .col-7.d-flex.align-items-center
                      small.d-block.mb-0 {{ user.display_name }}
                    .col-5
                      small.mb-0.text-justify 備註名：
                    .col-7.d-flex.align-items-center
                      small.d-block.mb-0 {{ user.note_name }}
                    .col-5
                      small.mb-0.text-justify ECM ID：
                    .col-7.d-flex.align-items-center
                      small.d-block.mb-0 {{ user.member_code }}
                .col-3.pl-1.d-flex.flex-column.justify-content-top.align-items-center
                  b-badge.px-2.py-1.text-center(
                    variant="primary",
                    v-if="user.unread_number > 0"
                  ) NEW
                  small.mb-0.d-block.w-100.text-right.text-center(
                    v-else
                  ) 已讀取
                .col-12
                  .row.no-gutters
                    .col-5.px-1
                      small.mb-0 客戶TR：
                      b-badge(
                        variant="primary",
                        class="rounded-0 p-1"
                      ) {{ TRList.includes(user.member_level) ? user.member_level : '' }}
                    .col-7.pl-1
                      small.mb-0 性別：
                      b-badge(
                        variant="primary",
                        class="rounded-0 p-1"
                      ) {{ genderList.includes(user.member_gender) ? user.member_gender : '' }}
        hr.border.border-primary.w-100
        .px-3.pb-3
          small.mb-3.d-block.w-100 {{ user | filterMessage }}
          small.mb-0.d-block.w-100.text-right {{ moment(user.last_message_at.split(' ')[0]).format('MM/DD')  }}
      infinite-loading(
        @infinite="infiniteHandler",
        :identifier="infiniteId",
        spinner="bubbles"
      )
        .cursor-default(slot="no-more") 無更多資料
        .cursor-default(slot="no-results") 無更多資料
        .cursor-default(slot="error") 發生錯誤，請重整重試一次
</template>

<script>
import { mapState } from 'vuex';
import { SM_CHAT_ROOM_INDEX } from '@/router/sm/chat-room';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import InfiniteLoading from 'vue-infinite-loading';
// websocket 監聽
import Echo from 'laravel-echo';

const moment = require('moment');
const _ = require('lodash');

export default {
  name: 'MsgManagerIndex',
  components: {
    ProfilePhotoSticker,
    InfiniteLoading
  },
  data() {
    return {
      infiniteId: +new Date(),
      selectedTab: 2,
    };
  },
  filters: {
    // 過濾最後一則訊息
    filterMessage(value) {
      // 使用者名稱
      const userName = value.display_name;
      // JSON化訊息
      let message = JSON.parse(value.message);
      // 用來放會回傳的訊息
      let returnText = '';
      // 判斷是 user 傳送或是 host 傳送
      // m2p 為 user 傳送 => '會員toCA'
      if (value.direction === 'm2p') {
        // 判斷種類
        switch (message.type) {
          case 'text':
            returnText = message.text;
            break;
          case 'image':
            returnText = `${userName}傳送了圖片`;
            break;
          case 'video':
            returnText = `${userName}傳送了影片`;
            break;
          case 'voice':
            returnText = `${userName}傳送了語音訊息`;
            break;
          case 'sticker':
            returnText = `${userName}傳送了貼圖`;
            break;
          case 'location':
            returnText = `${userName}向您傳送了位置訊息`;
            break;
          default:
            returnText = `${userName}向您傳送了一則訊息`;
            break;
        }
        return returnText;
      }
        // 其餘都是 host 傳送
        // p2m => 'CAto會員', s2m => '系統to會員', s2p => '系統toCA'

        // 判斷種類
        // 如果是模板，取最後一筆重組
        if (message.type === 'template') {
          message = _.last(message.data);
        }
        switch (message.type) {
          case 'text':
            if (Object.keys(message.text).length > 22) {
              returnText = `${message.text.replace(/\s+/g, '').substr(0, 22) }...`;
            } else if (Object.keys(message.text).length < 1) {
              returnText = '文字訊息已傳送';
            } else {
              returnText = message.text;
            }
            break;
          case 'image':
            returnText = '圖片已傳送';
            break;
          case 'video':
            returnText = '影片已傳送';
            break;
          case 'voice':
            returnText = '語音訊息已傳送';
            break;
          case 'sticker':
            returnText = '貼圖已傳送';
            break;
          case 'location':
            returnText = '位置訊息已傳送';
            break;
          case 'carousel':
            returnText = '橫向捲軸已傳送';
            break;
          default:
            returnText = '您傳送了一則訊息';
            break;
        }
        return returnText;
    }
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '請稍候，\n載入中',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.commit('sm_msg_manager/resetHandler');
    vm.$swal.close();
    vm.$store.commit('toggleLoading', false);
  },
  mounted() {
    const vm = this;
    // websocket
    window.io = require('socket.io-client');
    window.Echo = new Echo({
      broadcaster: 'socket.io',
      host: process.env.VUE_APP_WEBSOCKET_URL,
      transports: ['websocket', 'polling', 'flashsocket'],
      auth: {
        headers: {
          Authorization: window.sessionStorage.getItem('token'),
          Source: 'one-to-one'
        }
      }
    });
    // 加入 Channel
    const channelName = `one_to_one_${vm.smData.id}_${process.env.VUE_APP_LINE_MESSAGE_CHANNEL_ID}`;
    window.Echo.private(channelName)
      .listen('.line.one-to-one-frontend', () => {
        // 收到事件 e 為收到的 data
        vm.$store.commit('sm_msg_manager/resetHandler');
        vm.infiniteId += 1;
      });
  },
  methods: {
    getMessage(selectedTab) {
      this.$store.commit('sm_msg_manager/resetHandler');
      this.selectedTab = selectedTab;
      this.infiniteId += 1;
    },
    moment(date = null) {
      return date ? moment(date) : moment();
    },
    infiniteHandler($state) {
      const vm = this;
      let apiName = 'chat';
      if (vm.selectedTab === 2) apiName = 'unread';
      if (vm.selectedTab === 3) apiName = 'favorite';
      vm.$store.dispatch('sm_msg_manager/getChatListHandler', {
        current_page: vm.pagination.current_page + 1,
        per_page: vm.pagination.per_page,
        apiName: apiName
      }).then(() => {
        if (vm.pagination.current_page === 0 || vm.pagination.total_page === 0) {
          $state.complete();
        }

        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    openMsgHandler(user) {
      const vm = this;
      const userWhitPicture = user;

      if (vm.personnelProfilePicture) {
        userWhitPicture.sa_picture = vm.personnelProfilePicture;
      }
      vm.$router.push({
        name: SM_CHAT_ROOM_INDEX,
        params: {
          chatRoomTitle: `與${user.display_name}對話`,
          user
        }
      });
    }
  },
  computed: {
    ...mapState({
      msgList: (state) => state.sm_msg_manager.msgList,
      pagination: (state) => state.sm_msg_manager.pagination,
      personnelProfilePicture: (state) => state.sm_msg_manager.personnelProfilePicture,
      smData: (state) => state.sm.smData,
      TRList: (state) => state.sa.TRList,
      genderList: (state) => state.sa.genderList,
    })
  },
  beforeDestroy() {
    // 離開前結束 websocket 監聽事件
    window.Echo.disconnect();
  }
};
</script>

<style lang="scss" scoped>
.tabDiv {
  & div {
    width: 33%;
    text-align: center;
    border: solid 1px;
    padding: 10px;
    &.active {
      background-color: #67C2BB;
    }
    &:nth-child(2) {
      width: 34%;
      border-left: none;
      border-right: none;
    }
  }
}
</style>
